export default __webpack_public_path__ + "static/media/aws.b5dd7187.svg";